import React, { PropTypes as T } from 'react';
import Cookies from 'js-cookie';

export default class CollapsibleList extends React.Component {
  static propTypes = {
    title: T.any.isRequired,
    children: T.node.isRequired,
    open: T.bool,
    transition: T.string,
    onOpen: T.func,
    onClose: T.func,
    onToggle: T.func,
    persistState: T.bool,
    persistantStateId: T.string,
    activeLanguage: T.string
  };

  static defaultProps = {
    transition: 'height 300ms ease-in-out',
    onOpen: Function.prototype,
    onClose: Function.prototype,
    onToggle: Function.prototype
  };

  constructor (props) {
    super(props);

    this.state = {
      open: !!this.props.open ||
      (!!this.props.persistState &&
        !!JSON.parse(Cookies.get(this.props.persistantStateId) || null)) ||
      true,
      height: 0,
      transition: ''
    };
  }

  componentDidMount () {
    if (this.content) {
      const { height } = this.content.getBoundingClientRect();
      this.setState({ height: height });
      setTimeout(() => {
        this.setState({ transition: this.props.transition });
      }, 0);
    }
  }

  handleToggle = () => {
    this.setState(
      prevState => ({ open: !prevState.open }),
      () => {
        this.props.onToggle(this.state.open);
        this.state.open
          ? this.props.onOpen(this.state.open)
          : this.props.onClose(this.state.open);
        if (this.props.persistState) {
          Cookies.set(this.props.persistantStateId, this.state.open);
        }
      }
    );
  };

  render () {
    const contentStyle = {
      overflow: 'hidden',
      height: this.state.open ? this.state.height : 0,
      transition: this.state.transition
    };

    let title = this.props.title;
    const activeLanguage = this.props.activeLanguage;

    // if we're passed a react component, we pass the state
    if (React.isValidElement(this.props.title)) {
      title = React.cloneElement(this.props.title, {
        collapsibleIsOpen: this.state.open
      });
    }

    const titleClass = !this.state.open ? 'collapsible__title' : 'collapsible__title collapsible__title--opened';

    return (
      <div>
        <div
          className={titleClass}
          style={{ cursor: 'pointer' }}
          role="button"
          aria-pressed={this.state.open}
          onClick={this.handleToggle}
        >
          {title}
          <span>{activeLanguage}</span>
        </div>
        <div className="collapsible__content" style={contentStyle}>
          <div
            ref={c => {
              this.content = c;
            }}
          >
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/collapsibleList/index.js